import React from "react";
import { Button } from "@mui/material";
import cssStyles from "./cms_renderer.module.scss";
import { SectionData, ComponentRenderProps } from "./index";
import { trackItem } from "@/utils";

interface CustButtonProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
    index?: number;
}

const getButton = (sectionData: SectionData, index: number) => {
    // ...existing getButton code...
    const color = (sectionData.color as any) || (sectionData.uiCompType?.options?.color as any) || "primary"
    const size = (sectionData.uiCompType?.options?.size as any) || "small";
    const target = sectionData.newTab as any || sectionData.uiCompType?.options?.newTab ? "_blank" : "_self"
    // @ts-ignore
    return (
        <Button
            {...(!sectionData.onClick?.method && { component: "a" })}
            key={sectionData.trackId || ('Button_' + (index))}
            id={sectionData.trackId || ('Button_' + (index))}
            color={color}
            href={sectionData.link}
            {...(!sectionData.onClick?.method && { target: target })}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                trackItem(sectionData?.trackInfo || sectionData?.onClick?.input?.trackInfo || {});
                if (sectionData.onClick?.method) {
                    // @ts-ignore
                    if (typeof window[sectionData.onClick.method] === 'function') {
                        // @ts-ignore
                        window[sectionData.onClick.method](sectionData.onClick.input);
                    } else {
                        console.warn(`Global function ${sectionData.onClick.method} not found.`);
                    }
                }
            }}
            style={{ ...sectionData.uiCompType?.styles }}
            className={cssStyles[sectionData.uiCompType?.className || "custButton"]}
            size={size}
        >
            {sectionData.title}
        </Button>
    );
};

const CustButton = ({ sectionData, props, index = 1 }: CustButtonProps): JSX.Element | null => {
    // ...existing CustButton code...
    const panelClassName = "custButton";
    const button = getButton(sectionData, index);

    return sectionData.uiCompType?.parentStyles ? (
        <div style={{ ...sectionData.uiCompType?.parentStyles }}>
            {button}
        </div>
    ) : (
        <span>
            {button}
        </span>
    );
}
export default CustButton;
